<template>
  <div>
    <nav aria-label="breadcrumb" class="content-block">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#/simpeg-dashboard">Dashboard</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
          Daftar Riwayat Cuti
        </li>
        <li class="breadcrumb-item">
          <a href="#/cuti-setting-list">Daftar Pengaturan Cuti</a>
        </li>
        <li class="breadcrumb-item">
          <a href="#/libur-list">Daftar Hari Libur Libur</a>
        </li>
      </ol>
    </nav>

    <div class="content-block">
      <h5>Daftar Riwayat Cuti</h5>
    </div>
    <LogPopupTemplate ref="logPopup" />

    <DxPopup
      v-if="cutiBersamaSource"
      :visible="popupCutiBersamaVisible"
      title="Tambah Cuti Bersama"
      :drag-enabled="false"
      :hide-on-outside-click="false"
      :height="500"
      :width="550"
    >
      <div class="dx-fieldset">
        <DxValidationGroup ref="refValidationCutiBersama">
          <div class="dx-field">
            <div class="dx-field-label">No. Surat</div>
            <div class="dx-field-value">
              <DxTextBox
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                width="100%"
                label="No. Surat"
                v-model="cutiBersamaSource.no_sk"
              >
              </DxTextBox>
            </div>
          </div>

          <div class="dx-field">
            <div class="dx-field-label">Tgl Surat</div>
            <div class="dx-field-value">
              <DxDateBox
                label="Tgl Surat"
                type="date"
                :display-format="'dd/MM/yyyy'"
                :format="'dd/MM/yyyy'"
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                width="100%"
                v-model="cutiBersamaSource.tgl_sk"
              >
              </DxDateBox>
            </div>
          </div>

          <div class="dx-field">
            <div class="dx-field-label">Tanggal Mulai</div>
            <div class="dx-field-value">
              <DxDateBox
                :use-mask-behavior="false"
                label="Tanggal Mulai"
                type="date"
                :display-format="'dd/MM/yyyy'"
                :format="'dd/MM/yyyy'"
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                width="100%"
                v-model="cutiBersamaSource.tgl_mulai"
                @value-changed="onTglCutiBersamaChanged('tgl_mulai')"
              >
                <DxValidator>
                  <DxRequiredRule />
                </DxValidator>
              </DxDateBox>
            </div>
          </div>

          <div class="dx-field">
            <div class="dx-field-label">Tanggal Akhir</div>
            <div class="dx-field-value">
              <DxDateBox
                :use-mask-behavior="false"
                label="Tanggal Akhir"
                type="date"
                :display-format="'dd/MM/yyyy'"
                :format="'dd/MM/yyyy'"
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                width="100%"
                v-model="cutiBersamaSource.tgl_akhir"
                @value-changed="onTglCutiBersamaChanged('tgl_akhir')"
              >
                <DxValidator>
                  <DxRequiredRule />
                </DxValidator>
              </DxDateBox>
            </div>
          </div>
          <div class="dx-field">
            <div class="dx-field-label">Lama Cuti (hari)</div>
            <div class="dx-field-value">
              <DxTextBox
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                width="100%"
                label="Lama Cuti (hari)"
                :disabled="true"
                v-model="cutiBersamaSource.lama_cuti"
              >
                <DxValidator>
                  <DxNumericRule
                    min="1"
                    message="Lama cuti harus lebih dari 0"
                  />
                </DxValidator>
              </DxTextBox>
            </div>
          </div>

          <div class="dx-field">
            <div class="dx-field-label">Status Pegawai</div>
            <div class="dx-field-value" style="display: flex; gap: 16px">
              <label style="display: flex; align-items: center">
                <input
                  type="checkbox"
                  v-model="cutiBersamaSource.pegawai_status_id"
                  :value="1"
                  checked
                />
                <span style="margin-left: 6px">Direksi</span>
              </label>
              <label style="display: flex; align-items: center">
                <input
                  type="checkbox"
                  v-model="cutiBersamaSource.pegawai_status_id"
                  :value="2"
                />
                <span style="margin-left: 6px">Pegawai Tetap</span>
              </label>
              <label style="display: flex; align-items: center">
                <input
                  type="checkbox"
                  v-model="cutiBersamaSource.pegawai_status_id"
                  :value="3"
                />
                <span style="margin-left: 6px">Calon Pegawai</span>
              </label>
            </div>
          </div>

          <div class="dx-field">
            <div class="dx-field-label">Status Pengajuan Cuti</div>
            <div class="dx-field-value">
              <DxSelectBox
                :dataSource="commonStore.statusPengajuanStore"
                valueExpr="val"
                displayExpr="nama"
                width="100%"
                label="Status Pengajuan Cuti"
                placeholder="Status Pengajuan Cuti"
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                v-model="cutiBersamaSource.status"
                :disabled="!can('gaji-approve')"
              >
              </DxSelectBox>
            </div>
          </div>
        </DxValidationGroup>
      </div>

      <DxToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="before"
        :options="cancelButtonOptions"
      />

      <DxToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="after"
        :options="confirmButtonOptions"
      />
    </DxPopup>

    <DxPopup
      :visible="loadingVisible"
      :title="loadingTitle"
      :drag-enabled="false"
      :hide-on-outside-click="false"
      width="300"
      :height="130"
    >
      <div class="d-flex justify-content-center">
        <div
          class="spinner-border"
          style="width: 3rem; height: 3rem"
          role="status"
        ></div>
      </div>
    </DxPopup>
    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <DxDataGrid
          :focused-row-enabled="true"
          ref="dataGrid"
          :data-source="cutiListStore.dataSourceCutiList"
          :allow-column-reordering="true"
          :show-borders="true"
          :show-column-lines="false"
          :column-auto-width="true"
          :column-hiding-enabled="false"
          @exporting="onExporting"
          @editing-start="onEditingStart"
          @init-new-row="initNewRow($event)"
          @row-removing="onRowRemoving"
          @row-inserting="onInserting"
          @row-updating="(e) => onUpdating(e)"
          @saved="onSaved"
          @saving="onSaving"
          :word-wrap-enabled="true"
          :height="gridHeight"
          :remote-operations="true"
          :scrolling="{
            mode: 'virtual',
            rowRenderingMode: 'virtual',
            columnRenderingMode: 'virtual',
            useNative: true,
          }"
          @context-menu-preparing="onContextMenuPreparing($event)"
        >
          <!-- :filter-value="filterValue"
        :filter-sync-enabled="true" -->
          <!-- @selection-changed="onSelectionChanged" -->
          <DxHeaderFilter :visible="true" />

          <DxScrolling mode="virtual" />
          <DxFilterRow :visible="true" apply-filter="auto" />
          <DxPager
            :visible="true"
            :showPageSizeSelector="false"
            :showNavigationButtons="false"
            :show-info="true"
            :infoText="'Page {0} of {1} ({2} items)'"
          />
          <DxPaging :enabled="true" :page-size="numberingPageSize" />
          <DxExport :enabled="true" />
          <DxEditing
            :allow-updating="
              allowUpdate(can('absensi-update'), can('gaji-approve'))
            "
            :allow-deleting="can('absensi-del')"
            :allow-adding="can('absensi-create')"
            :mode="dxEditingMode"
            v-bind="commonFunction.editingConfig(dxEditingMode, 'cuti')"
          />
          <!--  -->
          <DxSelection mode="multiple" :deferred="true" />
          <DxToolbar>
            <DxItem
              location="after"
              template="status-setujui-selection-template"
              v-if="can('gaji-approve')"
            />
            <DxItem
              location="after"
              template="status-tolak-selection-template"
              v-if="can('gaji-approve')"
            />
            <DxItem
              location="after"
              template="cuti-bersama-selection-template"
              v-if="can('absensi-create')"
            />
            <DxItem location="after" template="refresh-template" />
            <DxItem name="groupPanel" />
            <DxItem name="addRowButton" show-text="always" />
            <DxItem name="exportButton" />
            <DxItem name="columnChooserButton" />
            <DxItem name="searchPanel" />
          </DxToolbar>
          <template #refresh-template>
            <DxButton
              icon="refresh"
              @click="refreshDatagrid('dataGrid')"
              text="Refresh Data"
              type="default"
              style="float: left"
              width="160px"
              styling-mode="outlined"
            ></DxButton>
          </template>
          <template #status-setujui-selection-template>
            <DxButton
              v-if="can('gaji-approve')"
              icon="check"
              @click="onSelectRowsConfirm(1)"
              text="Setujui Pilihan"
              type="success"
              style="float: left"
              styling-mode="outlined"
            ></DxButton>
          </template>
          <template #status-tolak-selection-template>
            <DxButton
              v-if="can('gaji-approve')"
              icon="close"
              @click="onSelectRowsConfirm(2)"
              text="Tolak Pilihan"
              type="danger"
              style="float: left"
              styling-mode="outlined"
            ></DxButton>
          </template>
          <template #cuti-bersama-selection-template>
            <DxButton
              v-if="can('absensi-create')"
              icon="edit"
              @click="openPopupCutiBersama"
              text="Tambah Cuti Bersama"
              style="float: left"
              styling-mode="outlined"
            ></DxButton>
          </template>
          <DxColumnFixing :enabled="true" />
          <!-- cell-template="diff-cell-template" -->

          <DxColumn
            caption="#"
            data-field="row_number"
            :allow-filtering="false"
            :allow-sorting="false"
            :allow-exporting="false"
            :fixed="true"
            fixed-position="left"
            data-type="number"
          />

          <dx-column
            data-field="id"
            caption="id"
            data-type="number"
            :visible="false"
          />

          <dx-column
            data-field="pegawai_id"
            caption="pegawai_id"
            data-type="number"
            :visible="false"
          />
          <DxColumn
            data-field="cutis_status"
            caption="Status Pengajuan Cuti"
            :allowHeaderFiltering="true"
            :header-filter="{
              dataSource:
                commonStore.statusPengajuanSource2('cutis_status').value,
            }"
            cell-template="templateStatus"
            :allow-editing="can('gaji-approve')"
            :fixed="true"
            fixed-position="left"
          >
            <DxRequiredRuleDataGrid />
            <DxLookup
              display-expr="nama"
              value-expr="val"
              :data-source="commonStore.statusPengajuanStore"
            />
          </DxColumn>

          <DxColumn
            data-type="string"
            data-field="simpeg_pegawais_nik"
            caption="NIK"
            :fixed="true"
            fixed-position="left"
            :allowHeaderFiltering="false"
            :allow-editing="can('absensi-update')"
          >
          </DxColumn>

          <dx-column
            data-field="simpeg_pegawais_nama"
            caption="Nama Pegawai"
            :visible="true"
            :allow-filtering="true"
            :allowHeaderFiltering="true"
            :allow-sorting="true"
            :header-filter="{
              dataSource: commonStore.getPegawaiSource(pegawaiSource).value,
            }"
            :fixed="true"
            fixed-position="left"
            :allow-editing="can('absensi-update')"
            :min-width="200"
            :filterOperations="['contains', 'startswith']"
            edit-cell-template="editPegawaiTemplate"
          >
            <!-- USE ALL PEGAWAI FOR THIS COLUMN -->
            <DxRequiredRuleDataGrid />
          </dx-column>

          <template #editPegawaiTemplate="{ data: cellInfo }">
            <!-- FOR THIS COLUMN, USER PEGAWAI BASED ON TGL MULAI -->

            <DxSelectBox
              ref="selectDxediting"
              :dataSource="pegawaiBasedOnTglSource"
              valueExpr="id"
              width="100%"
              :styling-mode="stylingMode"
              :label-mode="labelMode"
              :searchEnabled="true"
              :value="selectedPegawaiId"
              @valueChanged="handlePegawaiChange($event, cellInfo)"
              :display-expr="
                (item) => {
                  if (!item) return '';
                  if (item.nik) return `${item.nik} - ${item.nama}`;
                  return `- ${item.nama}`;
                }
              "
            />
          </template>

          <DxColumn
            :allow-hiding="false"
            class="noteditable"
            data-field="golongans_nama"
            caption="Gol."
            :allowHeaderFiltering="true"
            :header-filter="{
              dataSource: commonStore.getGolonganSource().value,
            }"
            :allow-editing="can('absensi-update')"
            :editor-options="{ disabled: true }"
          />

          <DxColumn
            class="noteditable"
            caption="golongan_id"
            data-field="golongan_id"
            :visible="false"
          />

          <DxColumn
            class="noteditable"
            caption="riwayat_pekerjaan_id"
            data-field="riwayat_pekerjaan_id"
            :visible="false"
          />

          <DxColumn
            :allow-hiding="false"
            class="noteditable"
            data-field="jabatan_print"
            caption="Jabatan"
            :allowHeaderFiltering="false"
            :allow-editing="can('absensi-update')"
            :editor-options="{ disabled: true }"
          />
          <DxColumn
            dataField="cuti_jenis_id"
            caption="Jenis Cuti"
            :allowHeaderFiltering="true"
            :allow-filtering="false"
            :allow-editing="can('absensi-update')"
            :header-filter="{
              dataSource: commonStore.getCutiJenisSource('crud').value,
            }"
            :set-cell-value="handleCutiJenisSetCellValue"
          >
            <DxRequiredRuleDataGrid />
            <DxLookup
              display-expr="nama"
              value-expr="id"
              :data-source="cutiJenisStore"
            />
          </DxColumn>

          <DxColumn
            data-field="no_sk"
            caption="No. Surat"
            :allowHeaderFiltering="false"
            :allow-editing="can('absensi-update')"
          >
          </DxColumn>

          <DxColumn
            data-field="tgl_sk"
            caption="Tgl Surat"
            data-type="date"
            :display-format="'dd/MM/yyyy'"
            :format="'dd/MM/yyyy'"
            :allowHeaderFiltering="false"
            :allow-editing="can('absensi-update')"
          >
          </DxColumn>

          <DxColumn
            data-field="tgl_mulai"
            caption="Tgl Mulai"
            data-type="date"
            :display-format="'dd/MM/yyyy'"
            :format="'dd/MM/yyyy'"
            :allowHeaderFiltering="false"
            :allow-editing="can('absensi-update')"
            :set-cell-value="handleTglSetCellValue('tgl_mulai')"
          >
            <!-- :editor-options="{
              onValueChanged: onTglValueChanged($event, cellInfo),
            }" -->
            <!-- @valueChanged="onTglValueChanged($event, cellInfo)" -->

            <DxRequiredRuleDataGrid />
          </DxColumn>

          <DxColumn
            data-field="tgl_akhir"
            caption="Tgl Akhir"
            data-type="date"
            :display-format="'dd/MM/yyyy'"
            :format="'dd/MM/yyyy'"
            :allowHeaderFiltering="false"
            :allow-editing="can('absensi-update')"
            :set-cell-value="handleTglSetCellValue('tgl_akhir')"
          >
            <DxRequiredRuleDataGrid />
          </DxColumn>

          <DxColumn
            data-field="lama_cuti"
            caption="Lama Cuti (Hari)"
            :allowHeaderFiltering="false"
            data-type="number"
            :allow-editing="can('absensi-update')"
            :editor-options="{ disabled: true }"
          >
            <DxRequiredRuleDataGrid />
          </DxColumn>

          <DxColumn
            data-field="cutis_alamat"
            :allowHeaderFiltering="false"
            caption="Alamat Pegawai Selama Cuti"
          >
          </DxColumn>
          <DxColumn
            data-field="ket_pejabat"
            :allowHeaderFiltering="false"
            caption="Catatan Pejabat Kepegawaian"
          >
          </DxColumn>

          <DxColumn
            data-field="ket_atasan"
            :allowHeaderFiltering="false"
            caption="Catatan/Pertimbangan Atasan Langsung"
          >
          </DxColumn>
          <DxColumn
            :allowHeaderFiltering="false"
            :allow-filtering="false"
            :allow-sorting="true"
            :allow-exporting="false"
            :allow-editing="true"
            :allow-adding="true"
            cell-template="fileTemplate"
            caption="Dokumen"
            data-field="file_path"
            data-type="string"
            edit-cell-template="editFileTemplate"
          >
          </DxColumn>

          <template #editFileTemplate="{ data }">
            <div>
              <DxFileUploader
                ref="fileUploaderRef"
                accept="*"
                upload-mode="useForm"
                @value-changed="onFileValueChanged($event, { data })"
                @uploaded="onUploaded($event, { data })"
              />
            </div>
          </template>
          <template #fileTemplate="{ data }">
            <div class="small-button-container">
              <DxButton
                :visible="setPrintAdaFile(data.text)"
                @click="
                  commonFunction.handleClickDocument(
                    data,
                    data.data.simpeg_pegawais_nama + ' - File Cuti',
                  )
                "
                icon="download"
              />
            </div>
          </template>
          <DxColumn
            caption="Dibuat oleh"
            :allowHeaderFiltering="false"
            data-field="created_at_text"
            :allowFiltering="false"
            :allow-sorting="false"
            :allow-exporting="false"
            :allow-updating="false"
          />

          <DxColumn
            caption="Diubah oleh"
            :allowHeaderFiltering="false"
            data-field="updated_at_text"
            :allowFiltering="false"
            :allow-sorting="false"
            :allow-exporting="false"
            :allow-updating="false"
          />

          <DxColumn
            caption="Disetujui oleh"
            :allowHeaderFiltering="false"
            data-field="approved_at_text"
            :allowFiltering="false"
            :allow-sorting="false"
            :allow-exporting="false"
            :allow-updating="false"
          />

          <template #templateStatus="{ data }">
            <StatusPengajuanTemplate :value="data.value" />
          </template>

          <!-- <template #templateCreatedBy="{ data }">
            {{ commonFunction.viewCreatedBy(data.data) }}
          </template> -->
          <DxColumn type="buttons" :width="110">
            <DxButtonDataGrid name="edit" />
            <DxButtonDataGrid name="delete" />
            <DxButtonDataGrid
              hint="View Log Perubahan"
              icon="clock"
              :visible="true"
              @click="this.$refs.logPopup.showBySubject($event, 'Cuti')"
            />
          </DxColumn>
        </DxDataGrid>
      </div>
    </div>
  </div>
</template>

<script>
import LogPopupTemplate from "./LogPopupTemplate.vue";
import DxValidationGroup from "devextreme-vue/validation-group";
import { API_BASE_URL } from "@/global-constants";
import { DxFileUploader } from "devextreme-vue/file-uploader";
import { useNaikPangkatListStore } from "@/stores/views/naik-pangkat-list-store";
import { DxSelectBox } from "devextreme-vue/select-box";
import notify from "devextreme/ui/notify";
import { usePegawaiListStore } from "@/stores/views/pegawai-list-store";
import auth from "../auth";
import * as commonFunction from "@/utils/common-function.js";
import { BASE_URL } from "@/global-constants";
import StatusPengajuanTemplate from "./StatusPengajuanTemplate.vue";
import { useCutiListStore } from "@/stores/views/cuti-list-store";
import { useLiburListStore } from "@/stores/views/libur-list-store";
import { useCommonStore } from "@/stores/utility/common-store2";
import { confirm } from "devextreme/ui/dialog";
import can from "@/haspermission";
import {
  DxValidator,
  DxRequiredRule,
  DxNumericRule,
} from "devextreme-vue/validator";
import DxButton from "devextreme-vue/button";
import { DateTime } from "luxon";
import _ from "lodash";
import { DxPopup, DxToolbarItem } from "devextreme-vue/popup";
import DxDropDownButton from "devextreme-vue/drop-down-button";
import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxPaging,
  DxFilterRow,
  DxLookup,
  DxPager,
  DxColumnFixing,
  DxExport,
  DxToolbar,
  DxItem,
  DxScrolling,
  DxButton as DxButtonDatagrid,
  DxSummary,
  DxTotalItem,
  DxHeaderFilter,
  DxRequiredRule as DxRequiredRuleDataGrid,
  DxSelection,
  DxButton as DxButtonDataGrid,
} from "devextreme-vue/data-grid";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from "file-saver";
import DxTextBox from "devextreme-vue/text-box";
import DxDateBox from "devextreme-vue/date-box";
import { useDukListStore } from "@/stores/views/duk-list-store";
import { useCutiSettingListStore } from "@/stores/views/cuti-setting-list-store";
import api from "@/api";
import axios from "axios";
/* eslint-disable */
export default {
  components: {
    DxValidationGroup,
    confirm,
    DxTextBox,
    DxDateBox,
    DxDataGrid,
    // eslint-disable-next-line
    DxColumn,
    DxPager,
    DxPaging,
    DxEditing,
    DxFilterRow,
    // eslint-disable-next-line
    DxLookup,
    DxColumnFixing,
    // DxSelection,
    DxExport,
    DxToolbar,
    DxButton,
    DxButtonDatagrid,

    DxPopup,
    DxToolbarItem,
    DxItem,
    DxDropDownButton,

    DxSummary,
    DxTotalItem,
    DxScrolling,
    DxHeaderFilter,
    StatusPengajuanTemplate,
    DxRequiredRule,
    DxSelectBox,
    DxSelection,
    DxFileUploader,
    DxValidator,

    DxRequiredRuleDataGrid,
    DxNumericRule,
    LogPopupTemplate,
    DxButtonDataGrid,
  },
  setup() {
    const cutiListStore = useCutiListStore();
    const commonStore = useCommonStore();
    const pegawaiListStore = usePegawaiListStore();
    const naikPangkatListStore = useNaikPangkatListStore();
    const cutiSettingListStore = useCutiSettingListStore();
    const dukListStore = useDukListStore();
    const liburListStore = useLiburListStore();

    return {
      liburListStore,
      cutiListStore,
      cutiSettingListStore,
      commonStore,
      commonFunction,
      pegawaiListStore,
      naikPangkatListStore,
      dukListStore,
    };
  },
  data() {
    const vm = this;
    return {
      logPopupRef: null,
      loadingTitle: "Loading...",
      cancelButtonOptions: {
        text: "Close",
        type: "danger",
        onClick: () => {
          this.popupCutiBersamaVisible = false;
        },
      },

      confirmButtonOptions: {
        text: "Tambah Cuti Bersama",
        onClick: async () => {
          const result =
            this.$refs.refValidationCutiBersama.instance.validate();
          if (!result.isValid) return;

          if (
            !this.cutiBersamaSource.lama_cuti ||
            this.cutiBersamaSource.lama_cuti <= 0
          ) {
            notify("Lama Cuti Bersama harus lebih dari 0.", "error");
            return;
          }

          if (
            !this.cutiBersamaSource.pegawai_status_id ||
            this.cutiBersamaSource.pegawai_status_id.length === 0
          ) {
            notify(
              "Pilih minimal satu Status Pegawai untuk penambahan Cuti Bersama.",
              "error",
            );
            return;
          }
          if (!this.cutiBersamaSource.valid) {
            notify(this.cutiBersamaSource.valid_message, "error");
            return;
          }
          await this.reloadPegawai(
            this.cutiBersamaSource.tgl_mulai,
            this.cutiBersamaSource.cuti_jenis_id,
          );
          this.popupCutiBersamaVisible = false;
          this.loadingTitle = "Menyimpan Cuti Bersama...";
          this.loadingVisible = true;
          await this.savingCutiBersama();
          this.loadingVisible = false;
        },
      },

      selectedPegawaiId: null,
      dxEditingMode: "popup", //row
      serverUrl: `${BASE_URL}/`,
      fileUrl: null,
      stylingMode: "filled",
      //outlined, filled, underlined
      labelMode: "floating",

      numberingPageSize: 100,
      buttonFilterPintasanVisible: false,
      pegawaiSource: [{ id: null, display_expr: null }],
      pegawaiBasedOnTglSource: [],
      selectedRows: [],
      tipeNaikPangkatStore: null,
      golonganStore: null,
      loadingVisible: false,
      selectedPegawaiId: null, // for editing pegawai
      cutiTglMulaiTemp: null,
      cutiSettingCurrentYear: null,
      cutiSettingNextYear: null,
      cutiUsedCurrentYear: null,
      cutiUsedNextYear: null,
      file: null,
      fileName: null,
      filePath: null,
      fileUrl: null,
      fileTitle: null,
      fileTableId: null,
      fileTable: null,
      popupCutiBersamaVisible: false,
      cutiJenisStore: null,
      cutiSettingCutiBersama: null,
      cutiBersamaSource: {
        tgl_mulai: null,
        tgl_akhir: null,
        pegawais: [], //pegawai_id, r_pekerjaan_id, golongan_id,
        cuti_jenis_id: 2, // Cuti Bersama
        no_sk: null,
        tgl_sk: null,
        lama_cuti: 0,
        status: 0,
        created_by_user_id: auth.getUser().id,
        pegawai_status_id: [1, 2],
        valid: true, // for validation
        valid_message: "",
        pegawais: null,
      },
    };
  },

  async created() {
    let filter = null;
    if (!_.isNil(this.$route.query.filter)) {
      filter = this.$route.query.filter;
    }
    this.cutiListStore.dataSourceCutiList.filter(filter);
    await this.commonStore.preloadStores();
  },

  async mounted() {
    // this.cutiJenisStore = this.commonStore.cutiJenisStore.filter(
    //   (item) => item.id !== 2
    // );
    this.cutiJenisStore = this.commonStore.cutiJenisStore;
    //cutibersama hanya bisa di add massal
    let tempA = await this.pegawaiListStore.dataSourcePegawaiListCoba(null, [
      {
        selector: "simpeg_pegawais.nama",
        desc: false,
      },
    ]);

    this.pegawaiSource = tempA.data; //all pegawai

    this.tipeNaikPangkatStore = this.commonStore.tipeNaikPangkatStore;
    // this.tipeNaikPangkatStore.unshift({ id: null, nama: null });
    // if (
    //   !this.tipeNaikPangkatStore.some(
    //     (item) => item.id === null && item.nama === null
    //   )
    // ) {
    //   this.tipeNaikPangkatStore.unshift({ id: null, nama: null });
    // }

    this.golonganStore = this.commonStore.golonganStore;
    if (
      !this.golonganStore.some((item) => item.id === null && item.nama === null)
    ) {
      this.golonganStore.unshift({ id: null, nama: null });
    }
  },

  computed: {
    gridHeight() {
      // Calculate grid height based on your requirements
      return "80vh"; // Set the height to fill the viewport vertically
    },
  },

  watch: {
    "cutiBersamaSource.tgl_akhir"(newDateValue) {
      if (newDateValue) {
        // this.cutiBersamaSource.tgl_awal = null;
      }
    },
  },

  methods: {
    async savingCutiBersama() {
      //validate jatah cutibersama

      const selectedStatusIds =
        this.cutiBersamaSource.pegawai_status_id.map(Number); // ensure numbers

      const pegawais = this.pegawaiBasedOnTglSource
        .filter((item) =>
          selectedStatusIds.includes(Number(item.pegawai_status_id)),
        )
        .map((item) => ({
          pegawai_id: item.id,
          riwayat_pekerjaan_id: item.riwayat_pekerjaan_id,
          golongan_id: item.golongan_id,
        }));

      //chek jatah, used and lama cuti. pakai pegawai[0] saja tidak usah foreach
      //karena sudah disetting bahwa cuti bersama adalah mass input
      //sehingga semua pegawai punya used cutibersama yang sama
      if (
        this.cutiBersamaSource.lama_cuti > this.cutiSettingCutiBersama[0].jatah
      ) {
        notify(
          `Lama Cuti Bersama (${this.cutiBersamaSource.lama_cuti}) melebihi jatah cuti bersama (${this.cutiSettingCutiBersama[0].jatah})`,
          "error",
        );
        this.cutiBersamaSource.valid = false;
        this.cutiBersamaSource.valid_message = `Lama Cuti Bersama (${this.cutiBersamaSource.lama_cuti}) melebihi jatah cuti bersama (${this.cutiSettingCutiBersama[0].jatah})`;

        return false;
      }

      if (
        this.cutiBersamaSource.lama_cuti + pegawais[0].cuti_used >
        this.cutiSettingCutiBersama[0].jatah
      ) {
        notify(
          `Jatah cuti tahun adalah ${this.cutiSettingCutiBersama[0].jatah} hari, sudah digunakan ${pegawais[0].cuti_used} hari, sehingga tidak bisa menambah Cuti Bersama sebanyak ${this.cutiBersamaSource.lama_cuti} hari`,
          "error",
        );
        this.cutiBersamaSource.valid = false;
        this.cutiBersamaSource.valid_message = `Jatah cuti tahun adalah ${this.cutiSettingCutiBersama[0].jatah} hari, sudah digunakan ${pegawais[0].cuti_used} hari, sehingga tidak bisa menambah Cuti Bersama sebanyak ${this.cutiBersamaSource.lama_cuti} hari`;

        return false;
      }

      this.cutiBersamaSource.tgl_mulai = DateTime.fromJSDate(
        new Date(this.cutiBersamaSource.tgl_mulai),
      ).toFormat("yyyy-MM-dd");
      this.cutiBersamaSource.tgl_akhir = DateTime.fromJSDate(
        new Date(this.cutiBersamaSource.tgl_akhir),
      ).toFormat("yyyy-MM-dd");

      if (this.cutiBersamaSource.status > 0) {
        this.cutiBersamaSource.approved_by_user_id = auth.getUser().id;
        this.cutiBersamaSource.approved_at = DateTime.now().toFormat(
          "yyyy-MM-dd HH:mm:ss",
        );
      }

      this.cutiBersamaSource.pegawais = pegawais;
      console.log("saving cutiBersamaSource", this.cutiBersamaSource);
      let insert = await this.cutiListStore.insertData(this.cutiBersamaSource);
      console.log("insert cutiBersamaSource", insert);
    },
    async onTglCutiBersamaChanged(field) {
      // When Tgl Mulai Cuti Bersama is changed, set Tgl Akhir to the same value

      this.cutiBersamaSource.valid = true;
      if (!this.cutiBersamaSource.tgl_mulai) {
        this.cutiBersamaSource.valid = false;
        this.cutiBersamaSource.valid_message =
          "Tanggal Mulai tidak boleh kosong";

        notify("Tanggal Mulai tidak boleh kosong", "error");
        return;
      }

      let tglMulai = DateTime.fromJSDate(
        new Date(this.cutiBersamaSource.tgl_mulai),
      ).toFormat("yyyy-MM-dd");
      let tglAkhir = this.cutiBersamaSource.tgl_akhir
        ? DateTime.fromJSDate(
            new Date(this.cutiBersamaSource.tgl_akhir),
          ).toFormat("yyyy-MM-dd")
        : tglMulai;

      if (DateTime.fromISO(tglMulai).year !== DateTime.fromISO(tglAkhir).year) {
        notify(
          "Tanggal Mulai dan Tanggal Akhir harus berada di tahun yang sama untuk Cuti Bersama.",
          "error",
        );
        this.cutiBersamaSource.valid = false;
        this.cutiBersamaSource.valid_message =
          "Tanggal Mulai dan Tanggal Akhir harus berada di tahun yang sama untuk Cuti Bersama.";
        return;
      }

      if (field === "tgl_mulai") {
        this.cutiSettingCutiBersama = await this.loadCutiSetting(
          tglMulai,
          this.cutiBersamaSource.cuti_jenis_id,
        );

        if (
          !this.cutiSettingCutiBersama ||
          this.cutiSettingCutiBersama.length === 0
        ) {
          notify(
            "Pengaturan Cuti Bersama tidak ditemukan untuk tanggal ini",
            "error",
          );
          this.cutiBersamaSource.valid = false;
          this.cutiBersamaSource.valid_message =
            "Pengaturan Cuti Bersama tidak ditemukan untuk tanggal ini";
          return;
        }
        // await this.reloadPegawai(
        //   tglMulai,
        //   this.cutiBersamaSource.cuti_jenis_id
        // );
      }

      let res = this.validateTglAkhirLessThanTglMulai(tglMulai, tglAkhir);

      if (!res) {
        this.cutiBersamaSource.valid_message =
          "Tanggal Akhir tidak boleh kurang dari Tanggal Mulai";
        this.cutiBersamaSource.valid = false;

        this.cutiBersamaSource.lama_cuti = 0;
        return;
      }

      this.cutiBersamaSource.lama_cuti = await this.hitungLamaCuti(
        tglMulai,
        tglAkhir,
      );
    },
    openPopupCutiBersama() {
      this.popupCutiBersamaVisible = true;
    },
    async downloadFile() {
      if (this.fileUrl === null || this.fileUrl === "") {
        notify("File tidak ada", "error");
        return;
      }

      try {
        const response = await api.post(
          `${API_BASE_URL}/arsip/download`,
          { file_path: this.fileUrl },
          {
            responseType: "blob",
            headers: {
              Authorization: api.defaults.headers.common["Authorization"],
            },
          },
        );
        const blob = new Blob([response.data], {
          type: response.headers["content-type"],
        });

        // Extract file extension from Content-Disposition header
        const contentDisposition = response.headers["content-disposition"];
        const urlParts = this.fileUrl.split(".");
        const extension =
          urlParts.length > 1 ? urlParts[urlParts.length - 1] : "";
        let filename =
          "Arsip Pegawai - " +
          this.dataSourcePegawai.nama +
          " - " +
          this.fileTitle +
          " - " +
          this.fileTableId +
          "." +
          extension;

        if (contentDisposition) {
          const match = contentDisposition.match(/filename="?([^"]+)"?/);
          if (match && match[1]) {
            filename = match[1];
          }
        }

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);

        // Append the link to the body (required for Firefox)
        document.body.appendChild(link);

        // Trigger the download
        link.click();

        // Cleanup
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
      } catch (error) {
        console.error(error);
        notify("Dokumen gagal didownload.", "error");
      }

      return;
    },
    handleClickDocument(e, title) {
      if (e.data.file_path !== null) {
        this.fileUrl = e.data.file_path;
        if (title === "File Arsip") {
          title =
            title + " - " + e.data.arsip_kategoris_nama + " - " + e.data.nama;
        }

        this.fileTitle = title;
        this.fileTableId = e.data.id;
        this.downloadFile();
      }
    },

    uuidv4() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          var r = (Math.random() * 16) | 0,
            v = c === "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        },
      );
    },

    onFileValueChanged(e, cellInfo) {
      const uploadButton = e.element.querySelector(
        ".dx-fileuploader-upload-button",
      );
      const fileContainer = e.element.querySelector(
        ".dx-fileuploader-files-container",
      );
      if (uploadButton) {
        uploadButton.style.display = "none"; // Hide the upload button
      }
      if (fileContainer) {
        fileContainer.style.display = "block"; // Hide the file container
      }

      if (e.value && e.value[0]) {
        const fileNameTemp = e.value[0].name;
        const fileExtension = fileNameTemp.substring(
          fileNameTemp.lastIndexOf(".") + 1,
        );
        this.file = e.value[0];
        console.log("onFileValueChanged file", this.file);
        var guid = this.uuidv4();
        this.fileName = guid + "." + fileExtension;
        this.filePath = "files/" + this.fileName;
        cellInfo.data.setValue(this.filePath);
      }
    },

    async loadCutiSetting(tgl, cutiJenisId) {
      console.log("loadCutiSetting", cutiJenisId, tgl);

      // Ensure tgl is set to 1 January of its year using Luxon
      // Ensure tgl is a string in ISO format for Luxon
      if (tgl instanceof Date) {
        tgl = DateTime.fromJSDate(tgl).toISODate();
      } else if (typeof tgl === "string" && tgl.includes("GMT")) {
        // Try to parse string date like "Fri Aug 01 2025 00:00:00 GMT+0800"
        tgl = DateTime.fromJSDate(new Date(tgl)).toISODate();
      }
      const tglAwalTahun = DateTime.fromISO(tgl)
        .set({ month: 1, day: 1 })
        .toFormat("yyyy-MM-dd");

      return await this.cutiSettingListStore.loadData([
        ["cuti_jenis_id", "=", cutiJenisId],
        ["tgl", "=", tglAwalTahun],
      ]);
    },

    async loadLibur(tglAwal, tglAkhir = null) {
      // Ensure tgl is set to 1 January of its year using Luxon
      // Ensure tgl is a string in ISO format for Luxon

      if (tglAkhir === null) {
        tglAkhir = tglAwal;
      }
      if (tglAwal instanceof Date) {
        tglAwal = DateTime.fromJSDate(tglAwal).toISODate();
      } else if (typeof tglAwal === "string" && tglAwal.includes("GMT")) {
        // Try to parse string date like "Fri Aug 01 2025 00:00:00 GMT+0800"
        tglAwal = DateTime.fromJSDate(new Date(tglAwal)).toISODate();
      }

      if (tglAkhir) {
        if (tglAkhir instanceof Date) {
          tglAkhir = DateTime.fromJSDate(tglAkhir).toISODate();
        } else if (typeof tglAkhir === "string" && tglAkhir.includes("GMT")) {
          // Try to parse string date like "Fri Aug 01 2025 00:00:00 GMT+0800"
          tglAkhir = DateTime.fromJSDate(new Date(tglAkhir)).toISODate();
        }
      }

      if (tglAwal === tglAkhir) {
        // If tglAwal and tglAkhir are the same, set tglAkhir to null
        tglAkhir = tglAwal;
      }
      tglAwal = DateTime.fromISO(tglAwal).toFormat("yyyy-MM-dd");
      tglAkhir = DateTime.fromISO(tglAkhir).toFormat("yyyy-MM-dd");

      return await this.liburListStore.loadData([
        ["tipe", "<>", "Cuti Bersama"],
        "and",
        [["tgl", ">=", tglAwal], "and", ["tgl", "<=", tglAkhir]],
      ]);
    },

    async handleCutiJenisSetCellValue(newData, value, currentRowData) {
      const cutiJenisId = value;
      const tgl = newData.hasOwnProperty("tgl_mulai")
        ? newData.tgl_mulai
        : currentRowData.tgl_mulai;

      console.log("TGL", tgl);
      newData.cuti_jenis_id = cutiJenisId;
      if (!tgl) return;
      this.cutiSettingCurrentYear = await this.loadCutiSetting(
        tgl,
        cutiJenisId,
      );
    },
    handleTglSetCellValue(fieldName) {
      console.log("handleTglSetCellValue", fieldName);
      return async (newData, value, currentRowData) => {
        const cutiJenisId = newData.hasOwnProperty("cuti_jenis_id")
          ? newData.cuti_jenis_id
          : currentRowData.cuti_jenis_id;

        if (!cutiJenisId) {
          notify("Jenis cuti harus diisi terlebih dahulu", "error");
          return;
        }
        newData[fieldName] = value;

        if (fieldName === "tgl_akhir") this.cutiSettingNextYear = null;
        if (fieldName === "tgl_mulai" && value) {
          // Do something specific for tgl_mulai
          this.cutiTglMulaiTemp = DateTime.fromJSDate(new Date(value)).toFormat(
            "yyyy-MM-dd",
          );
          let tgl = DateTime.fromJSDate(new Date(value)).toFormat("yyyy-MM-dd");
          console.log("handleTglSetCellValue beforereload", fieldName);
          await this.reloadPegawai(tgl, cutiJenisId);
          this.cutiSettingCurrentYear = await this.loadCutiSetting(
            tgl,
            cutiJenisId,
          );
        } else if (fieldName === "tgl_mulai" && !value) {
          // If tgl_akhir is cleared, reset related fields
          this.cutiTglMulaiTemp = null;
          this.pegawaiBasedOnTglSource = [];
          this.selectedPegawaiId = null;
          newData.jabatan_print = null;
          newData.golongans_nama = null;
          newData.golongan_id = null;
          newData.tgl_mulai = null;
          newData.riwayat_pekerjaan_id = null;
        }

        const tglMulai = newData.hasOwnProperty("tgl_mulai")
          ? newData.tgl_mulai
          : currentRowData.tgl_mulai;
        const tglAkhir = newData.hasOwnProperty("tgl_akhir")
          ? newData.tgl_akhir
          : currentRowData.tgl_akhir;

        console.log("tglmulai ", tglMulai);
        console.log("tglAkhir ", tglAkhir);
        // Validation: tgl_akhir should not be less than tgl_mulai
        let res = this.validateTglAkhirLessThanTglMulai(tglMulai, tglAkhir);
        if (!res) {
          newData.tgl_akhir = null;
          newData.lama_cuti = null;
          return;
        }

        newData.lama_cuti = await this.hitungLamaCuti(tglMulai, tglAkhir);
      };
    },

    async hitungLamaCuti(tglMulai, tglAkhir) {
      if (!tglMulai || !tglAkhir) return 0;

      // Calculate number of days excluding Saturday and Sunday
      let start = DateTime.fromJSDate(new Date(tglMulai)).startOf("day");
      let end = DateTime.fromJSDate(new Date(tglAkhir)).startOf("day");
      const liburResult = await this.loadLibur(start, end); // Load holidays between tglMulai and tglAkhir
      const libur = liburResult.map((item) => item.tgl);
      // const libur = liburResult.data.map((item) => item.tgl);
      console.log("libur", libur);

      let count = 0;
      let current = start;
      while (current <= end) {
        const day = current.weekday; // 1 = Monday, 7 = Sunday
        const currentDateStr = current.toFormat("yyyy-MM-dd");
        if (day !== 6 && day !== 7 && !libur.includes(currentDateStr)) {
          count++;
        }
        current = current.plus({ days: 1 });
      }
      return count;
    },

    validateTglAkhirLessThanTglMulai(tglMulai, tglAkhir) {
      if (
        tglMulai &&
        tglAkhir &&
        DateTime.fromJSDate(new Date(tglAkhir)).toFormat("yyyy-MM-dd") <
          DateTime.fromJSDate(new Date(tglMulai)).toFormat("yyyy-MM-dd")
      ) {
        // Set tgl_akhir to null

        // Show notification
        notify("Tanggal akhir tidak boleh kurang dari tanggal mulai", "error");
        // Clear lama_cuti as well

        return false; // Exit early\
      }
      return true;
    },

    async reloadPegawai(tgl, cutiJenisId = null) {
      this.loadingVisible = true;
      this.loadingTitle = "Memuat data pegawai...";
      try {
        const dataDuk = await this.dukListStore.getData([
          ["tgl", "=", tgl],
          ["capeg_tetap", "=", false],
          ["include_direksi", "=", true],
          ["cuti_jenis_id", "=", cutiJenisId],
        ]);
        this.pegawaiBasedOnTglSource = dataDuk.data;
        this.loadingVisible = false;
      } catch (error) {
        console.error("Error fetching dataDuk:", error);
        this.loadingVisible = false;
        this.pegawaiBasedOnTglSource = [];
        notify("Error fetching data pegawai " + error, "error");
      }
    },

    handlePegawaiChange(e, cellInfo) {
      if (!this.cutiTglMulaiTemp) {
        return;
      }

      this.selectedPegawaiId = e.value;
      cellInfo.setValue(e.value);
      const selectedPegawai = this.pegawaiBasedOnTglSource.find(
        (pegawai) => pegawai.id === this.selectedPegawaiId,
      );
      const rowIndex = cellInfo.component.getRowIndexByKey(
        cellInfo.component.option("editing.editRowKey"),
      );

      let jabatanPrint = selectedPegawai.riwayat_pekerjaans[0].jabatan_print;

      console.log("selectedPegawai", selectedPegawai);
      let riwayatPekerjaanId = selectedPegawai.riwayat_pekerjaan_id;
      let golNama = selectedPegawai.golongan_nama;
      let golId = selectedPegawai.golongan_id;
      if (rowIndex >= 0) {
        cellInfo.component.cellValue(rowIndex, "simpeg_pegawais_nama", e.value);
        cellInfo.component.cellValue(rowIndex, "jabatan_print", jabatanPrint);
        cellInfo.component.cellValue(rowIndex, "golongans_nama", golNama);
        cellInfo.component.cellValue(rowIndex, "golongan_id", golId);
        cellInfo.component.cellValue(
          rowIndex,
          "riwayat_pekerjaan_id",
          riwayatPekerjaanId,
        );
      }
      // cellInfo.row.data.jabatan_print =
      //   selectedPegawai.riwayat_pekerjaans[0].jabatan_print;
      // cellInfo.row.data.riwayat_pekerjaan_id =
      //   selectedPegawai.riwayat_pekerjaan_id;
      // cellInfo.row.data.golongans_nama = selectedPegawai.golongan_nama;
      // cellInfo.row.data.golongan_id = selectedPegawai.golongan_id;
    },

    hitungMasaKerja(tgl, tglMulaiBekerja) {
      tglMulaiBekerja = DateTime.fromISO(tglMulaiBekerja).set({ day: 1 });

      tgl = DateTime.fromJSDate(new Date(tgl)).set({ day: 1 });

      const diff = tgl.diff(tglMulaiBekerja, ["years", "months"]);

      const years = Math.floor(diff.years); // Get full years
      const months = Math.floor(diff.months); // Get full months

      return { years: years, months: months };
    },

    async hitungMasaKerjaNaikPangkat(
      tgl,
      tglMulaiBekerja,
      golonganId,
      capeg = false,
    ) {
      let masaKerja = this.hitungMasaKerja(tgl, tglMulaiBekerja);
      if (capeg) masaKerja.years = 1; // jika capeg, masa kerja 1 tahun
      else {
        masaKerja.years = masaKerja.years - 2;
        if (golonganId > 8) {
          masaKerja.years = masaKerja.years - 5;
        }
      }
      return masaKerja;
    },

    async hitungMasaKerjaKgb(tgl, tglMulaiBekerja) {
      let masaKerja = this.hitungMasaKerja(tgl, tglMulaiBekerja);
      let tglNaikPangkatC1 = null;
      const naikPangkatC1 = await this.getAllDataNaikPangkat();

      if (naikPangkatC1.length > 0) {
        tglNaikPangkatC1 = _.minBy(
          naikPangkatC1,
          (item) => new Date(item.tgl),
        ).tgl;
      }
      if (tglNaikPangkatC1) {
        if (
          DateTime.fromJSDate(new Date(tgl)) >=
          DateTime.fromISO(tglNaikPangkatC1)
        )
          // .set({ day: 1 }) perlukah untuk argsvalue and tglnaikpangkatc1?
          masaKerja.years = masaKerja.years - 5;
      }
      console.log("hitungMasaKerjaKgb mk", masaKerja);
      masaKerja.years = masaKerja.years - 2;
      return masaKerja;
    },

    async getAllDataNaikPangkat() {
      let filter = [
        ["pegawai_id", "=", this.selectedPegawaiId],
        "and",
        ["golongans_id", ">", 8],
      ];
      return await this.naikPangkatListStore.loadData(filter);
    },

    getPegawaiId(data) {
      console.log("getPegawaiId", data);
      if (data.value === undefined) {
        return null; //insert
      }
      return data.data.pegawai_id;
    },
    showData(data) {
      console.log("showData", data);
      // return data.simpeg_pegawais_nama;
    },
    onContextMenuPreparing(e) {
      console.log("onContextMenuPreparing", e);
      if (e.target == "content") {
        e.element.id = e.row.data.pegawai_id;
        const data = {}; // Declare a constant object
        data.pegawai_id = e.row.data.pegawai_id;

        // e.items can be undefined
        if (e.row.isEditing) return;
        if (!e.items) e.items = [];

        if (
          this.allowUpdate(this.can("pegawai-update"), this.can("gaji-approve"))
        ) {
          e.items.push({
            text: "Edit Cuti",
            icon: "edit",

            onItemClick: () => {
              e.component.editRow(e.rowIndex);
            },
          });
        }

        e.items.push({
          text: "Lihat Detail Pegawai",
          icon: "user",
          beginGroup: true,
          onItemClick: () => {
            e.itemData = "Detail Pegawai";
            this.onItemClick(e, data);
          },
        });

        e.items.push({
          text: "Lihat Absensi",
          icon: "event",
          onItemClick: () => {
            e.itemData = "Absensi";
            this.onItemClick(e, data);
          },
        });

        e.items.push({
          text: "Riwayat Gaji",
          icon: "money",
          onItemClick: () => {
            e.itemData = "Riwayat Gaji";
            this.onItemClick(e, data);
          },
        });
      }
    },

    templateCreatedByUser(cellElement, cellInfo) {
      cellElement.innerText = this.commonFunction.viewCreatedByUser(
        cellInfo.data,
      );
      // return
    },

    validasiNaikPangkatUpdate(lama, baru, kolom) {
      let jenis = lama.jenis;
      if (!_.isNil(baru.jenis)) {
        jenis = baru.jenis;
      } //jenis pengajuan mengikuti perubahan data yang terbaru

      if (
        !_.isNil(baru.jenis) &&
        baru.jenis === "KP" &&
        _.isUndefined(baru[kolom])
      ) {
        //perubahan dari kgb ke kp dan tidak melakukan perubahan golongan/jenisnaikpangkat
        return false;
      }
      if (_.isNull(baru[kolom])) {
        // golongan_id is undefined
        return false;
      }

      return true;
    },

    validasiNaikPangkatUpdate2(lama, baru, kolom) {
      let jenis = lama.jenis;
      if (!_.isNil(baru.jenis)) {
        jenis = baru.jenis;
        if (jenis === "KP") {
          if (_.isNil(baru[kolom])) {
            console.log("test tidak boleh diupdate KP 3");
            return false;
          }
        }
      } //jenis pengajuan mengikuti perubahan data yang terbaru

      console.log("test " + kolom + " JENIS", jenis);
      console.log("test " + kolom + " LAMA", lama[kolom], _.isNil(lama[kolom]));
      console.log("test " + kolom + " BARU", baru[kolom], _.isNil(baru[kolom]));

      if (jenis === "KP" && _.isNil(lama[kolom]) && _.isNil(baru[kolom])) {
        //nil = null or undefined
        console.log("test tidak boleh diupdate KP 1");
        return false;
      } else if (
        jenis === "KP" &&
        !_.isNil(lama[kolom]) &&
        _.isNil(baru[kolom])
      ) {
        console.log("test tidak boleh diupdate KP 2");
        return false;
      }

      if (jenis === "KGB" && _.isNil(lama[kolom]) && _.isNil(baru[kolom])) {
        //nil = null or undefined
        console.log("test tidak boleh diupdate KGB 1");
        return false;
      } else if (
        jenis === "KGB" &&
        !_.isNil(lama[kolom]) &&
        !_.isNil(baru[kolom])
      ) {
        console.log("test tidak boleh diupdate KGB 2");
        return false;
      }
      console.log("test BOLEH UPDATE");
      return true;
    },

    validasiNaikPangkat(data, kolom) {
      if (data.jenis === "KP" && (!data[kolom] || data[kolom] === null)) {
        console.log("test golongan tidak boleh diinsert KP");
        return false;
      } else if (data.jenis === "KGB" && data[kolom] && data[kolom] !== null) {
        console.log("test golongan tidak boleh diinsert KGB");
        return false;
      } else {
        console.log("test bisa insert golongan");
        return true;
      }
    },

    async onInserting(e) {
      // Always set updated_by_user_id

      // If status = 2, set approval fields
      e.data.updated_by_user_id = auth.getUser().id;
      e.data.status = e.data.cutis_status;
      if (e.data.cutis_status > 0) {
        e.data.approved_by_user_id = auth.getUser().id;
        e.data.approved_at = DateTime.now().toFormat("yyyy-MM-dd HH:mm:ss");
      }
      console.log("onInserting e", e);
      const isCanceled = new Promise(async (resolve, reject) => {
        try {
          if (e.data.simpeg_pegawais_nama) {
            e.data.pegawai_id = e.data.simpeg_pegawais_nama;
            delete e.data.simpeg_pegawais_nama;
          }
          if (e.data.cutis_status) {
            e.data.status = e.data.cutis_status;
          }
          const valid = await this.validateCuti(e.data);
          if (valid) {
            resolve(false); // Don't cancel - allow update
          } else {
            reject("Cuti validation failed. Please check your data."); // Cancel with error message
          }
        } catch (error) {
          console.error("Validation error:", error);
          reject("Error during validation: " + error.message);
        }
      });
      e.cancel = isCanceled;
    },

    async onUpdating(e) {
      // Always set updated_by_user_id

      // If status = 2, set approval fields
      e.newData.updated_by_user_id = auth.getUser().id;
      if (e.newData.cutis_status > 0) {
        e.newData.approved_by_user_id = auth.getUser().id;
        e.newData.approved_at = DateTime.now().toFormat("yyyy-MM-dd HH:mm:ss");
      }
      // Merge oldData and newData to get the full row
      console.log("onUpdating e", e);
      const isCanceled = new Promise(async (resolve, reject) => {
        try {
          if (e.newData.simpeg_pegawais_nama) {
            e.newData.pegawai_id = e.newData.simpeg_pegawais_nama;
            delete e.newData.simpeg_pegawais_nama;
          }
          if (e.newData.cutis_status) {
            e.newData.status = e.newData.cutis_status;
          }
          const mergedData = { ...e.oldData, ...e.newData };
          if (e.newData.hasOwnProperty("cutis_status")) {
            // Do something if cutis_status exists in newData
            // Example: console.log('cutis_status:', e.newData.cutis_status);
            console.log("cutis_status:", e.newData.cutis_status);
          }
          console.log("debug onUpdating e", mergedData);
          console.log("debug onUpdating mergedData", mergedData);
          const valid = await this.validateCuti(mergedData);
          console.log("debug hasil valid", valid);
          if (valid) {
            resolve(false); // Don't cancel - allow update
          } else {
            reject("Cuti validation failed. Please check your data."); // Cancel with error message
          }
        } catch (error) {
          console.error("Validation error:", error);
          reject("Error during validation: " + error.message);
        }
      });

      e.cancel = isCanceled;
    },

    async onSaved() {
      if (!this.file) return;
      const formData = new FormData();
      formData.append("fileName", this.fileName);
      formData.append("file", this.file);

      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "multipart/form-data",
        },
      };
      axios
        .post(`${API_BASE_URL}/arsip/upload_store`, formData, config)
        .then((response) => {
          notify(response.data.message, response.data.notify_type);
          this.file = null;
          this.fileName = null;
          this.filePath = null;
        })
        .catch((error) => {
          this.file = null;
          this.fileName = null;
          this.filePath = null;
          console.error(error);
          notify("Gagal upload file", "error");
        });
    },

    async validateCuti(data, cutiSetting = null) {
      if (!data.tgl_mulai || !data.tgl_akhir || !data.cuti_jenis_id) {
        notify("Tanggal mulai, akhir, dan jenis cuti harus diisi.", "error");
        return false;
      }

      if (!data.lama_cuti || data.lama_cuti === 0) {
        alert(data.lama_cuti);
        notify("Lama Cuti harus lebih dari 0.", "error");
        return false;
      }

      const tglMulai = DateTime.fromJSDate(new Date(data.tgl_mulai)).startOf(
        "day",
      );
      const tglAkhir = DateTime.fromJSDate(new Date(data.tgl_akhir)).startOf(
        "day",
      );
      const cutiJenisId = data.cuti_jenis_id;

      const liburResult = await this.loadLibur(tglMulai, tglAkhir);
      const liburDates = liburResult.map((item) => item.tgl);

      // Split lama_cuti per year
      let yearCounts = {};
      let current = tglMulai;
      while (current <= tglAkhir) {
        const day = current.weekday; // 1 = Monday, 7 = Sunday
        const currentDateStr = current.toFormat("yyyy-MM-dd");
        if (day !== 6 && day !== 7 && !liburDates.includes(currentDateStr)) {
          const year = current.year;
          yearCounts[year] = (yearCounts[year] || 0) + 1;
        }
        current = current.plus({ days: 1 });
      }

      for (const year in yearCounts) {
        // Get jatah for this year
        const tglAwalTahun = DateTime.fromObject({
          year: Number(year),
          month: 1,
          day: 1,
        }).toFormat("yyyy-MM-dd");

        /*if cutiSetting is not provided, load it, cutiSetting is from savingCutiBersama
        when savingCutiBersama, set tgl awal is always in the same year as tglMulai, so it will not have to
        load cutiSetting for each year
        */
        const cutiSetting = await this.loadCutiSetting(
          tglAwalTahun,
          cutiJenisId,
        );
        if (!cutiSetting || cutiSetting.length === 0) {
          notify(
            `Peraturan Cuti untuk tahun ${year} tidak terdaftar. Tambahkan dahulu di pengaturan cuti`,
            "error",
          );
          return false;
        }
        const jatah = cutiSetting[0].jatah;

        // Get cutiUsed for this year
        let cutiUsed = 0;
        let dukData = await this.dukListStore.getData([
          ["tgl", "=", tglAwalTahun],
          ["capeg_tetap", "=", false],
          ["include_direksi", "=", true],
          ["cuti_jenis_id", "=", cutiJenisId],
          ["pegawai_id", "=", this.selectedPegawaiId],
        ]);
        if (dukData && dukData.data.length > 0) {
          cutiUsed = dukData.data[0].cuti_used;
        }

        // Validate for this year
        if (yearCounts[year] > jatah) {
          notify(
            `Lama cuti di tahun ${year} (${yearCounts[year]} hari) melebihi jatah cuti ${jatah} hari`,
            "error",
          );
          return false;
        }
        if (yearCounts[year] + cutiUsed > jatah) {
          notify(
            `Jatah cuti tahun ${year} adalah ${jatah} hari, sudah digunakan ${cutiUsed} hari`,
            "error",
          );
          return false;
        }
      }

      return true;
    },

    async validateCutiLama(data) {
      // 1. Check required fields
      console.log("debug validateCuti", data);
      if (!data.tgl_mulai || !data.tgl_akhir || !data.cuti_jenis_id) {
        notify("Tanggal mulai, akhir, dan jenis cuti harus diisi.", "error");
        return false;
      }

      const tglMulai = data.tgl_mulai;
      const tglAkhir = data.tgl_akhir;
      const cutiJenisId = data.cuti_jenis_id;
      const tahunMulai = DateTime.fromJSDate(new Date(tglMulai)).year;
      const tahunAkhir = DateTime.fromJSDate(new Date(tglAkhir)).year;
      if (!this.cutiSettingCurrentYear) {
        console.log("debug error 1");
        notify(
          "Peraturan Cuti untuk jenis dan tahun cuti " +
            tahunMulai +
            " tidak terdaftar. Tambahkan dahulu di pengaturan cuti",
          "error",
        );
        return false;
      }

      //cari tgl_mulai dan tgl_akhir, if tgl_akhir is not the same year as tgl_mulai, then load cutiSettingNextYear
      //after that, get cutiUsed for pegawai in tgl_akhir

      let cutiJatah = this.cutiSettingCurrentYear[0].jatah;
      console.log("debug cutiJatah", cutiJatah);
      let cutiUsed = this.pegawaiBasedOnTglSource.find(
        (pegawai) => pegawai.id === this.selectedPegawaiId,
      ).cuti_used;
      console.log("debug cutiUsed", cutiUsed);
      if (tahunMulai !== tahunAkhir) {
        // If not the same year, search cutiSetting for tgl_akhir
        const tglAkhirFormatted = DateTime.fromJSDate(
          new Date(tglAkhir),
        ).toFormat("yyyy-MM-dd");
        let cutiSettingNextYear = await this.loadCutiSetting(
          tglAkhirFormatted,
          cutiJenisId,
        );

        if (
          !cutiSettingNextYear ||
          cutiSettingNextYear === null ||
          cutiSettingNextYear.length === 0
        ) {
          console.log("debug error 2");
          notify(
            "Peraturan Cuti untuk jenis dan tahun cuti " +
              tahunAkhir +
              " tidak terdaftar. Tambahkan dahulu di pengaturan cuti",
            "error",
          );
          return false;
        }

        cutiJatah += cutiSettingNextYear[0].data.jatah;
        console.log("debug cutiJatah next year", cutiJatah);

        let dataDukNextYear = await this.dukListStore.getData([
          ["tgl", "=", tgl],
          ["capeg_tetap", "=", false],
          ["include_direksi", "=", true],
          ["cuti_jenis_id", "=", cutiJenisId],
          ["pegawai_id", "=", this.selectedPegawaiId],
        ]);

        if (!dataDukNextYear || dataDukNextYear.data.length === 0) {
          console.log("debug error 3");
          notify(
            "Data pegawai tidak ditemukan untuk tahun " + tahunAkhir,
            "error",
          );
          return false;
        }

        cutiUsed += dataDukNextYear.data[0].cuti_used;
        console.log("debug cutiUsed next year", cutiUsed);
        //cari cutiused pegawai di tahun akhir
      }

      let lamaCuti = data.lama_cuti;
      console.log("debug lamaCuti", lamaCuti);

      if (lamaCuti > cutiJatah) {
        console.log("debug error 4");
        notify(
          "Lama cuti tidak boleh melebihi jatah cuti " + cutiJatah + " hari",
          "error",
        );
        return false;
      }

      if (lamaCuti + cutiUsed > cutiJatah) {
        console.log("debug error 5");
        notify(
          "Jatah cuti adalah " +
            cutiJatah +
            " hari, sudah digunakan " +
            cutiUsed +
            " hari",
          "error",
        );
        return false;
      }

      return true; // Allow saving
    },
    // ...other methods...

    async onSaving(e) {
      console.log("test onSaving e", e);
      // if (e.changes && e.changes.length > 0 && e.changes[0].type === "update") {
      //   // Get old data from the grid
      //   const oldData = e.changes[0].key
      //     ? e.component.getRowByKey(e.changes[0].key)
      //     : {};
      //   const newData = e.changes[0].data || {};
      //   const mergedData = { ...oldData, ...newData };
      //   // const valid = await this.validateCuti(mergedData);
      //   // e.cancel = !valid;
      //   console.log("onSaving mergedData", mergedData);
      // }

      return;
      e.cancel = true;

      const tglMulai = e.changes[0].data.tgl_mulai;
      const tglAkhir = e.changes[0].data.tgl_akhir;
      const cutiJenisId = e.changes[0].data.cuti_jenis_id;
      const tahunMulai = DateTime.fromJSDate(new Date(tglMulai)).year;
      const tahunAkhir = DateTime.fromJSDate(new Date(tglAkhir)).year;
      if (!this.cutiSettingCurrentYear) {
        notify(
          "Peraturan Cuti untuk jenis dan tahun cuti " +
            tahunMulai +
            " tidak terdaftar. Tambahkan dahulu di pengaturan cuti",
          "error",
        );
        return;
      }

      //cari tgl_mulai dan tgl_akhir, if tgl_akhir is not the same year as tgl_mulai, then load cutiSettingNextYear
      //after that, get cutiUsed for pegawai in tgl_akhir
      console.log(
        "onSaving cutiSettingCurrentYear",
        this.cutiSettingCurrentYear,
      );
      let cutiJatah = this.cutiSettingCurrentYear[0].jatah;
      let cutiUsed = this.pegawaiBasedOnTglSource.find(
        (pegawai) => pegawai.id === this.selectedPegawaiId,
      ).cuti_used;
      if (tahunMulai !== tahunAkhir) {
        // If not the same year, search cutiSetting for tgl_akhir
        const tglAkhirFormatted = DateTime.fromJSDate(
          new Date(tglAkhir),
        ).toFormat("yyyy-MM-dd");
        let cutiSettingNextYear = await this.loadCutiSetting(
          tglAkhirFormatted,
          cutiJenisId,
        );
        console.log("onSaving cutiSettingNextYear", cutiSettingNextYear);
        if (
          !cutiSettingNextYear ||
          cutiSettingNextYear === null ||
          cutiSettingNextYear.length === 0
        ) {
          return notify(
            "Peraturan Cuti untuk jenis dan tahun cuti " +
              tahunAkhir +
              " tidak terdaftar. Tambahkan dahulu di pengaturan cuti",
            "error",
          );
        }

        cutiJatah += cutiSettingNextYear[0].data.jatah;

        let dataDukNextYear = await this.dukListStore.getData([
          ["tgl", "=", tgl],
          ["capeg_tetap", "=", false],
          ["include_direksi", "=", true],
          ["cuti_jenis_id", "=", cutiJenisId],
          ["pegawai_id", "=", this.selectedPegawaiId],
        ]);

        if (!dataDukNextYear || dataDukNextYear.data.length === 0) {
          notify(
            "Data pegawai tidak ditemukan untuk tahun " + tahunAkhir,
            "error",
          );
          return;
        }

        cutiUsed += dataDukNextYear.data[0].cuti_used;
        //cari cutiused pegawai di tahun akhir
      }

      let lamaCuti = e.changes[0].data.lama_cuti;

      if (lamaCuti > cutiJatah) {
        notify(
          "Lama cuti tidak boleh melebihi jatah cuti " + cutiJatah + " hari",
          "error",
        );
        return;
      }

      if (lamaCuti + cutiUsed > cutiJatah) {
        notify(
          "Jatah cuti adalah " +
            cutiJatah +
            " hari, sudah digunakan " +
            cutiUsed +
            " hari",
          "error",
        );
        return;
      }

      e.cancel = false; // Allow saving
    },
    onSelectRowsConfirm(status) {
      let result = confirm(
        "<strong>Yakin mengubah status Cuti?</strong> <br> Data yang sudah disetujui atau ditolak tidak dapat diubah lagi",
        "Konfirmasi Status Cuti",
      );
      result.then((dialogResult) => {
        if (dialogResult) {
          this.onSelectRows(status);
        }
      });
    },
    async onSelectRows(status) {
      //1 = setujui, 2 = tolak

      try {
        const dataGrid = this.$refs.dataGrid.instance;
        const selectedRows = await dataGrid.getSelectedRowsData();
        const filteredRows = selectedRows.filter(
          (row) => row.cutis_status <= 0,
        );
        const updatedRows = filteredRows.map((row) => ({
          ...row, // Spread the original row properties
          status: status, // Update the status to the provided value
          updated_by_user_id: auth.getUser().id,
          approved_by_user_id: auth.getUser().id,
          approved_at: DateTime.now().toFormat("yyyy-MM-dd HH:mm:ss"),
        }));

        console.log("Selected Row Keys ONSELECTROWS filter:", filteredRows);
        console.log("Selected Row Keys ONSELECTROWS updatedRows:", updatedRows);
        if (_.isEmpty(updatedRows)) {
          notify("Tidak ada data yang dapat diubah", "error");
          return;
        }
        // Call updateData method with updatedRows
        this.loadingVisible = true;
        this.loadingTitle = "Loading... ";
        const result = await this.cutiListStore.updateData(updatedRows);
        if (result) {
          notify("Berhasil mengubah status Cuti", "success");
          this.refreshDatagrid("dataGrid");
        }

        this.loadingVisible = false;
      } catch (error) {
        console.error("Error in onSelectRows:", error);
        this.loadingVisible = false;
        notify("Gagal mengubah status Cuti " + error, "error");
      }
    },

    onRowRemoving(e) {
      console.log("onRowRemoving e", e);
      if (e.data.cutis_status > 0) {
        e.cancel = true;
        notify(
          "Tidak dapat menghapus data yang sudah disetujui atau ditolak",
          "error",
        );
      }
    },
    async onEditingStart(e) {
      console.log("onEditingStart selectedpegawaiid", this.selectedPegawaiId);
      if (e.data.cutis_status > 0) {
        e.cancel = true;
        notify(
          "Tidak dapat mengedit data yang sudah disetujui atau ditolak",
          "error",
        );
        return;
      }

      const tgl = e.data.tgl_mulai;
      const cutiJenisId = e.data.cuti_jenis_id;

      this.cutiTglMulaiTemp = DateTime.fromJSDate(new Date(tgl)).toFormat(
        "yyyy-MM-dd",
      );

      // Call reloadPegawai with those values
      this.cutiSettingCurrentYear = await this.loadCutiSetting(
        tgl,
        cutiJenisId,
      );

      await this.reloadPegawai(tgl, cutiJenisId);

      if (
        !this.cutiSettingCurrentYear ||
        this.cutiSettingCurrentYear.length === 0
      ) {
        notify(
          "Peraturan Cuti untuk jenis dan tahun cuti tidak terdaftar. Tambahkan dahulu di pengaturan cuti",
          "error",
        );
        e.cancel = true;
        return;
      }

      this.selectedPegawaiId = e.data.pegawai_id;
    },

    allowUpdate(a, b) {
      if (a || b) return true;
      else return false;
    },
    initNewRow(e) {
      e.data.created_by_user_id = auth.getUser().id;
      e.data.cutis_status = 0;
      this.selectedPegawaiId = null;
      this.pegawaiBasedOnTglSource = [];
      console.log("initNewRow selectedpegawaiid", this.selectedPegawaiId);
    },
    displayCapeg(e) {
      if (e.value) {
        return "80%";
      }
    },
    setPrintAdaFile(e) {
      console.log("setPrintAdaFile ", e);
      if (_.isEmpty(e)) return false;
      else return true;
    },

    hilangFilter() {
      // this.absenStore.onMuatButtonClick();
      this.buttonFilterPintasanVisible = false;
    },
    onItemClick(e, data) {
      console.log("onItemClick e", e);
      console.log("onItemClick data", data);
      let pegawaiId = data.pegawai_id;

      if (e.itemData === "Absensi") {
        const url = this.$router.resolve({
          name: "absen-list-custom",
          query: { filter: ["absen_bulans_pegawai_id", "=", pegawaiId] },
        }).href;
        window.open(url, "_blank");
      }

      if (e.itemData === "Riwayat Gaji") {
        const url = this.$router.resolve({
          name: "gaji-history-custom",
          query: { filter: ["gajis_pegawai_id", "=", pegawaiId] },
        }).href;
        window.open(url, "_blank");
      }

      if (e.itemData === "Detail Pegawai") {
        const url = this.$router.resolve({
          name: "pegawai-detail-custom",
          query: { id: pegawaiId },
        }).href;
        window.open(url, "_blank");
      }
    },

    can,

    refreshDatagrid(gridRef) {
      // this.pengajuanListStore.dataSourcePengajuanList.filter(null);
      // this.$refs[gridRef].instance.clearFilter();
      this.$refs[gridRef].instance.getDataSource().reload();
    },

    onExporting(e) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("Riwayat Cuti");

      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            "Daftar Riwayat Cuti.xlsx",
          );
        });
      });
      e.cancel = true;
    },
  },
};
</script>
